import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
@Injectable()
export class SupportAccountService {
  support_basicVerifyUrl = '/superadmin/rest/support/account/verifyAccountBasic';
  support_basicplusVerifyUrl = '/superadmin/rest/support/account/verifyAccountBasicPlus';
 support_premiumVerifyUrl = '/superadmin/rest/support/account/verifyAccountPremium';


 basicVerifyUrl = '/superadmin/rest/mgmt/account/verifyAccount';
  basicplusVerifyUrl = '/superadmin/rest/mgmt/account/verifyAccount';
 premiumVerifyUrl = '/superadmin/rest/mgmt/account/verifyAccount';


 accountListUrl = '/superadmin/rest/support/account?';
 countUrl = '/superadmin/rest/support/account/count?';
  constructor(private http: HttpClient) { }

  basicVerify(data) {
    const userType = localStorage.getItem('userType');
        if (userType === 'support') {
        this.basicVerifyUrl = this.support_basicVerifyUrl;
        } else {
        this.basicVerifyUrl = this.basicVerifyUrl;
        }
    return this.http.put(this.basicVerifyUrl, data, {headers: headers});
  }
  basicplusVerify(data) {
    const userType = localStorage.getItem('userType');
    if (userType === 'support') {
    this.basicplusVerifyUrl = this.support_basicplusVerifyUrl;
    } else {
    this.basicplusVerifyUrl = this.basicplusVerifyUrl;
    }
    return this.http.put(this.basicplusVerifyUrl, data, {headers: headers});
  }
  premiumVerify(data) {
    const userType = localStorage.getItem('userType');
    if (userType === 'support') {
    this.premiumVerifyUrl = this.support_premiumVerifyUrl;
    } else {
    this.premiumVerifyUrl = this.premiumVerifyUrl;
    }
    return this.http.put(this.premiumVerifyUrl, data, {headers: headers});
  }


  getAccountsData(
    filter, sortOrder,
    pageNumber, pageSize):  Observable<any> {
    return this.http.get(this.accountListUrl + filter, {
        params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
    });
}
getTotalFilterCount(filter): Observable<any> {
  return this.http.get(this.countUrl + filter, {headers: headers});
}

}
